import { render, staticRenderFns } from "./RegionSelection.vue?vue&type=template&id=615a61a7&scoped=true&"
import script from "./RegionSelection.vue?vue&type=script&lang=js&"
export * from "./RegionSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a61a7",
  null
  
)

export default component.exports